import React, { useEffect, useState } from 'react';
import PortsAutoComplete from '../../../../common/PortsAutoComplete';

const CargoRegion = ({ cargoRegion, updateField }) => {
    const [region, setRegion] = useState(cargoRegion);

    useEffect(() => {
        setRegion(cargoRegion);
    }, [cargoRegion]);

    const selectPort = (value) => {
        updateField('cargoRegion', value);
    };
    
    return (
        <PortsAutoComplete 
            customValue={region.name || ''}
            selectValue={selectPort}
            floatingLabelText='Cargo region'
            hintText={null}
            inputStyle={{ fontSize: '13px', marginTop: '14px' }}
            menuStyle={{ width: '300px' }}
            style={{ display: 'flex', width: '100%' }}
            textFieldStyle={{ height: '72px' }}
            popoverProps={{
                style: { width: '300px' },
            }}
            withAreas
            onlyAreas
        />
    );
};

export default CargoRegion;



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Hire/content/CargoRegion.jsx